import React from 'react'
import * as R from 'ramda'
import Moment from 'moment'

import FloatingActionButton from 'material-ui/FloatingActionButton'
import {List, ListItem} from 'material-ui/List'
import ContentAdd from 'material-ui/svg-icons/content/add'


import RepairmanCard from './RepairmanCard'
import RepairmenFilters from './RepairmenFilters'
import YelpResults from 'components/YelpResults'
import RepairmenSelectCard from 'components/RepairmenSelectCard'
import ifc from 'components/ifc'
import { sortSevDesc } from 'utils/stuff'


export default (o) => {
	let scrollPos = 0
	return(
		<div
			id="main-content"
			style={{
				marginLeft: (typeof global.md.phone() == 'string' || o.repairmenSelect)?
						"0"
					: '55px'
			  , marginTop: (typeof global.md.phone() == "string" || (typeof global.md.tablet() == 'string' && window.innerWidth < window.innerHeight))?"5px":"60px"
			  , overflowY: "auto"
			  , overflowX: "hidden"
			  , height: (typeof global.md.phone() == "string" || (typeof global.md.tablet() == 'string' && window.innerWidth < window.innerHeight))?'calc(100vh - 60px)': (typeof global.md.tablet() == "string")? 'calc(100vh - 168px)' : 'calc(100vh - 60px)'
			  , width: (o.rightStackOpened || o.repairmenSelect)? (typeof global.md.phone() == 'string' || o.repairmenSelect )? "100%" : "calc(53% - 56px)" : `calc(100% - ${(typeof global.md.phone() == 'string' || o.repairmenSelect)? "0px" : "53px"})`
			}}
		>
			{(typeof global.md.phone() != 'string' && window.innerWidth > window.innerHeight)?
				<div
					className="desktop-filters"
					style={{
						marginTop: "0"
					  , paddingTop: "8px"
					  , marginRight: "0"
					}}
				>
					{/*<span
						style={{
							float: "left"
						  , margin: "2px 0 0 1px"
						}}
					>
						Filters:
					</span>*/}
					<RepairmenFilters
						filtersUPD={o.filtersUPD}
						repairmenFilters={o.repairmenFilters}
						data={o.data}
						properties={o.properties}
						switchYelp={o.switchYelp}
						yelpIsOn={o.yelpIsOn}
						updCategoryYelp={o.updCategoryYelp}
						yelpCategory={o.yelpCategory}
					/>
				</div>
				: ""
			}
			{(typeof global.md.phone() == "string" || (typeof global.md.tablet() == 'string' && window.innerWidth < window.innerHeight))?

				<div
					style={{
						backgroundColor: "#f7f7f8"
					  , textAlign: "center"
					}}
				>
					{(o.filters)?
						<div>
							<RepairmenFilters
								filtersUPD={o.filtersUPD}
								repairmenFilters={o.repairmenFilters}
								data={o.data}
								properties={o.properties}
								switchYelp={o.switchYelp}
								yelpIsOn={o.yelpIsOn}
								updCategoryYelp={o.updCategoryYelp}
								yelpCategory={o.yelpCategory}
							/>
							<div
								onClick={o.toggleFilt}
								style={{
									height: "55px"
								  , paddingRight: "30px"
								}}
							>
								<span
									className="arrow open"
									style={{
										position: "relative"
									  , right: "0"
									  , display: "inline-block"
									}}
								>

								</span>
							</div>
						</div>
						:<div
							onClick={o.toggleFilt}
						>
							<span
								style={{
									display: "inline-block"
								  , width: "8px"
								  , height: "8px"
								  , margin: "0 5px"
								  , borderRadius: "8px"
								  , backgroundColor: "#b3bdc2"
								}}
							></span>
							<span
								style={{
									display: "inline-block"
								  , width: "8px"
								  , height: "8px"
								  , margin: "0 5px"
								  , borderRadius: "8px"
								  , backgroundColor: "#b3bdc2"
								}}
							></span>
							<span
								style={{
									display: "inline-block"
								  , width: "8px"
								  , height: "8px"
								  , margin: "0 5px"
								  , borderRadius: "8px"
								  , backgroundColor: "#b3bdc2"
								}}
							></span>
						</div>
					}
				</div>
				: ""
			}
			{(typeof global.md.phone() != 'string')?
				<div
					style={{
						fontSize: "20px"
					  , marginTop: "31px"
					  , color: "#FFF"
					  , position: "fixed"
					  , zIndex: "1000"
					  , top: "-15px"
					  , left: "76px"
					}}
				>
					Repairmen ({o.count})
				</div>
				: ""
			}
			{(o.repairmenSelect)?
				<List
					style={{
						background: "transparent"
					  , marginTop: (typeof global.md.phone() == "string" || (typeof global.md.tablet() == 'string' && window.innerWidth < window.innerHeight))? "-5px" : "-14px"
					  , marginLeft: (typeof global.md.phone() == "string" || (typeof global.md.tablet() == 'string' && window.innerWidth < window.innerHeight))? "0" : "-12px"
					}}
				>
					{(R.keys(o.repairmen).length)?
						R.map((repairman) => (
							<RepairmenSelectCard
								key={`project-${repairman._id}`}
								repairman={repairman}
								id={repairman._id}
								property={{
									cors: (o.properties[o.property])? o.properties[o.property].cors : undefined
								  , _id: (o.properties[o.property])? o.properties[o.property]._id : undefined
								  , address: (o.properties[o.property])? o.properties[o.property].address : undefined
								}}
								PROJECT_REPAIRMAN_CHECK={o.PROJECT_REPAIRMAN_CHECK}
								projectID={o.projectID}
							/>
					),  sortSevDesc(o.repairmen, "distance", "rating"))
						: <p style={{marginLeft: "20px", marginTop: "12px",color: "#A0A0A0"}}>No repairmen</p>
					}
				</List>
				:
				<List
					style={{
						background: "transparent"
					  , marginTop: (typeof global.md.phone() == "string" || (typeof global.md.tablet() == 'string' && window.innerWidth < window.innerHeight))? "-5px" : "-14px"
					  , marginLeft: (typeof global.md.phone() == "string" || (typeof global.md.tablet() == 'string' && window.innerWidth < window.innerHeight))? "0" : "-12px"
					}}
				>
					{(R.keys(o.repairmen).length)?
						R.map((repairman) => (
							<RepairmanCard
								key={`project-${repairman._id}`}
								repairman={repairman}
								id={repairman._id}
								refTask={o.refTask}
								refQuoteProject={o.refQuoteProject}
								docUpd={o.docUpd}
								history={o.history}
								openPanel={o.openPanel}
								lastInteracted={o.lastInteracted}
								rightStackOpened = {o.rightStackOpened}
								property={{
									cors: (o.properties[o.property])? o.properties[o.property].cors : undefined
								  , _id: (o.properties[o.property])? o.properties[o.property]._id : undefined
								  , address: (o.properties[o.property])? o.properties[o.property].address : undefined
								}}
								docUpd={o.docUpd}
							/>
					),  sortSevDesc(o.repairmen, "distance", "rating"))
						: <p style={{marginLeft: "20px", marginTop: "12px",color: "#A0A0A0"}}>No repairmen</p>
					}
				</List>
			}
			<YelpResults />
		</div>
	)
}
/*{()=> {
}}*/



// WEBPACK FOOTER //
// ./src/routes/manager/repairmen/RepairmenList.js